import { Link, useLocation, useNavigate } from "react-router-dom";
import { Radio } from "lucide-react";
import { useState, useEffect } from "react";

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onLanding = location.pathname === "/";

    const goAnchor = (hash) => {
        if (!onLanding) {
            navigate("/" + hash);
        } else {
            const el = document.querySelector(hash);
            if (el) el.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-black/60 backdrop-blur-2xl border-b border-white/10"
                    : "bg-transparent"
            }`}
            data-testid="main-navbar"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-center gap-3 group"
                    data-testid="logo-link"
                >
                    <div className="relative">
                        <Radio className="w-6 h-6 text-amber-400 neon-flicker" strokeWidth={1.5} />
                    </div>
                    <div className="flex flex-col leading-none">
                        <span className="font-display text-base font-medium tracking-tight text-white">
                            Mon Séraphin
                        </span>
                        <span className="font-body text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                            Podcast Studio
                        </span>
                    </div>
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    <button
                        onClick={() => goAnchor("#formules")}
                        className="font-body text-sm text-zinc-300 hover:text-amber-300 transition-colors"
                        data-testid="nav-formules"
                    >
                        Formules
                    </button>
                    <button
                        onClick={() => goAnchor("#studio")}
                        className="font-body text-sm text-zinc-300 hover:text-amber-300 transition-colors"
                        data-testid="nav-studio"
                    >
                        Le Studio
                    </button>
                    <button
                        onClick={() => goAnchor("#galerie")}
                        className="font-body text-sm text-zinc-300 hover:text-amber-300 transition-colors"
                        data-testid="nav-galerie"
                    >
                        Galerie
                    </button>
                    <button
                        onClick={() => goAnchor("#faq")}
                        className="font-body text-sm text-zinc-300 hover:text-amber-300 transition-colors"
                        data-testid="nav-faq"
                    >
                        FAQ
                    </button>
                    <Link
                        to="/blog"
                        className="font-body text-sm text-zinc-300 hover:text-amber-300 transition-colors"
                        data-testid="nav-blog"
                    >
                        Blog
                    </Link>
                </nav>

                <Link
                    to="/reserver"
                    className="inline-flex items-center gap-2 rounded-md bg-amber-300 px-5 py-2 text-sm font-medium text-zinc-950 hover:bg-amber-200 transition-colors"
                    data-testid="nav-reserver-btn"
                >
                    Réserver
                </Link>
            </div>
        </header>
    );
}
